import { render, staticRenderFns } from "./SideTray.vue?vue&type=template&id=33294f6a&scoped=true"
import script from "./SideTray.vue?vue&type=script&lang=js"
export * from "./SideTray.vue?vue&type=script&lang=js"
import style0 from "./SideTray.vue?vue&type=style&index=0&id=33294f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33294f6a",
  null
  
)

export default component.exports